import React, { useState, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import {
  useSubscribeDataMutation,
  useSearchAllQuery,
} from "./Subcribemodelapislice";

const days = [
  { day: "Mon" },
  { day: "Tue" },
  { day: "Wed" },
  { day: "Thu" },
  { day: "Fri" },
  { day: "Sat" },
  { day: "Sun" },
];

export default function SubscribeModal({ closeModal }) {
  const username = "mohit123";
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [formData, setFormData] = useState({
    username: username,
    subscribeUsers: [],
    subject: "",
    repeats: "",
    at: "",
    on: "", // Single value for the selected day
    include: "This View",
    format: "image",
  });

  // Mutation hook for subscribing data
  const [
    subscribeData,
    {
      isLoading: isSubscribing,
      isSuccess: isSubscribeSuccess,
      isError: isSubscribeError,
    },
  ] = useSubscribeDataMutation();
  console.log(subscribeData);

  // Query hook for searching users
  const {
    data: searchResults,
    isLoading: isSearching,
    isError: isSearchError,
    error: searchError,
    isSuccess: isSearchSuccess,
  } = useSearchAllQuery({ data: inputValue });
  console.log(searchResults?.users);

  useEffect(() => {
    if (searchResults && searchResults.users) {
      setFilteredUsers(searchResults.users.map((user) => user.username));
    } else {
      setFilteredUsers([]);
    }
  }, [searchResults]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleUserSelect = (userName) => {
    if (!formData.subscribeUsers.includes(userName)) {
      setFormData((prevData) => ({
        ...prevData,
        subscribeUsers: [...prevData.subscribeUsers, userName],
      }));
    }
    setInputValue("");
    setFilteredUsers([]);
  };

  const removeUser = (userName) => {
    setFormData((prevData) => ({
      ...prevData,
      subscribeUsers: prevData.subscribeUsers.filter(
        (user) => user !== userName
      ),
    }));
  };

  const handleDayClick = (day) => {
    setFormData((prevData) => ({
      ...prevData,
      on: prevData.on === day ? "" : day,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await subscribeData({
        username,
        users: formData.subscribeUsers,
        subject: formData.subject,
        repeats: formData.repeats,
        at: formData.at,
        on: formData.on,
        include: formData.include,
        format: formData.format,
        cronTime: "35 14 * * *",
      }).unwrap();
      // Clear the form and close the modal on success
      setFormData({
        subscribeUsers: [],
        subject: "",
        repeats: "",
        at: "",
        on: "",
        include: "This View",
        format: "image",
        username,
      });
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSubmit(); // Call your function here
    }
  };

  return (
    <main
      className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-20"
      onKeyDown={handleKeyDown}
    >
      <main className="bg-white w-96 border rounded-lg shadow-lg p-1">
        <header className="flex justify-between items-center p-1 border-b">
          <h2 className="text-lg font-medium">Subscribe</h2>
          <RxCross2
            onClick={closeModal}
            className="cursor-pointer text-black"
          />
        </header>
        <form
          className="w-full flex flex-col items-center justify-center p-1 gap-3"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col items-start justify-start w-full">
            <label className="font-[400] text-black">Subscribe users:</label>
            <div className="w-full border rounded shadow-sm p-[6px] flex flex-wrap">
              {formData.subscribeUsers.map((userName, index) => (
                <span
                  key={index}
                  className="bg-gray-200 text-gray-800 px-2 py-1 rounded-full mr-2 mb-2 flex items-center"
                >
                  {userName}
                  <button
                    type="button"
                    className="ml-2 text-red-500"
                    onClick={() => removeUser(userName)}
                  >
                    &times;
                  </button>
                </span>
              ))}
              <input
                type="text"
                value={inputValue}
                onChange={handleChange}
                className="flex-grow p-[6px] border-none focus:outline-none focus:ring-0"
                autoComplete="off"
                placeholder="Type to search..."
              />
            </div>
            {isSearching && (
              <div className="text-gray-500 mt-2">Searching users...</div>
            )}
            {filteredUsers.length > 0 && (
              <ul className="absolute w-[23rem] border rounded mt-[7.5%] max-h-60 overflow-y-auto bg-white shadow-sm z-20">
                {filteredUsers.map((userName, index) => (
                  <li
                    key={index}
                    className="p-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => handleUserSelect(userName)}
                  >
                    {userName}
                  </li>
                ))}
              </ul>
            )}
            {isSearchError && (
              <div className="text-red-500 mt-2">
                Error fetching users. Please try again.
              </div>
            )}
          </div>

          <div className="flex flex-col items-start justify-start w-full">
            <label className="font-[400] text-black">Subject:</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={(e) =>
                setFormData({ ...formData, subject: e.target.value })
              }
              className="w-full p-[6px] border rounded shadow-sm focus:outline-none focus:ring-2"
            />
          </div>

          <div className="flex flex-wrap w-full gap-3">
            <div className="w-full flex items-center justify-center gap-2">
              <div className="w-[50%] flex flex-col items-start justify-center">
                <label className="font-[400] text-black">Repeats</label>
                <select
                  name="repeats"
                  value={formData.repeats}
                  onChange={(e) =>
                    setFormData({ ...formData, repeats: e.target.value })
                  }
                  aria-placeholder="Repeats"
                  className="w-full p-2 border rounded shadow-sm bg-white"
                >
                  <option value="Hourly">Hourly</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Month">Month</option>
                </select>
              </div>

              <div className="w-[50%] flex flex-col items-start justify-center">
                <label className="font-[400] text-black">At</label>
                <input
                  type="text"
                  name="at"
                  value={formData.at}
                  onChange={(e) =>
                    setFormData({ ...formData, at: e.target.value })
                  }
                  className="w-full p-[6px] border rounded shadow-sm focus:outline-none focus:ring-2"
                  placeholder="e.g., 08:40 AM"
                />
              </div>
            </div>

            <div className="w-full flex items-center justify-start gap-2">
              <label className="font-[400] text-black">On</label>
              {days.map((item, index) => (
                <span
                  key={index}
                  className={`cursor-pointer border rounded w-10 h-7 text-center font-light ${
                    formData.on === item.day
                      ? "bg-blue-950 text-white"
                      : "bg-gray-200"
                  }`}
                  onClick={() => handleDayClick(item.day)}
                >
                  {item.day}
                </span>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-start w-full">
            <label className="font-[400] text-black">Schedule:</label>
            {formData && (
              <span className="border-b w-full h-5 text-left font-light gap-1 flex">
                {formData.repeats} / {formData.at}
              </span>
            )}
          </div>

          <div className="flex w-full items-center justify-start gap-2">
            <label className="font-[400] text-black">Include:</label>
            <div className="flex items-center gap-2 ">
              <input
                id="thisView"
                name="include"
                type="radio"
                value="This View"
                checked={formData.include === "This View"}
                onChange={(e) =>
                  setFormData({ ...formData, include: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="thisView" className="font-light text-black">
                This View
              </label>
              <input
                id="entireWorkbook"
                name="include"
                type="radio"
                value="Entire Workbook"
                checked={formData.include === "Entire Workbook"}
                onChange={(e) =>
                  setFormData({ ...formData, include: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="entireWorkbook" className="font-light text-black">
                Entire Workbook
              </label>
            </div>
          </div>

          <div className="flex w-full items-center justify-start gap-2">
            <label className="font-[400] text-black">Format:</label>
            <div className="flex items-center gap-2 ">
              <input
                id="Image"
                name="format"
                type="radio"
                value="Image"
                checked={formData.format === "image"}
                onChange={(e) =>
                  setFormData({ ...formData, format: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="Image" className="font-light text-black">
                Image
              </label>
              <input
                id="Pdf"
                name="format"
                type="radio"
                value="PDF"
                checked={formData.format === "PDF"}
                onChange={(e) =>
                  setFormData({ ...formData, format: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="Pdf" className="font-light text-black">
                PDF
              </label>
            </div>
          </div>

          <div className="w-full flex items-center justify-end gap-4">
            <button
              type="button"
              onClick={closeModal}
              className="px-4 py-2 border border-gray-200 rounded-md text-black"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-950 text-white rounded-md"
              disabled={isSubscribing}
            >
              {isSubscribing ? "Subscribing..." : "schedule"}
            </button>
          </div>

          {isSubscribeError && (
            <div className="text-red-500 mt-2">
              Subscription failed. Please try again.
            </div>
          )}
          {isSubscribeSuccess && (
            <div className="text-green-500 mt-2">Subscription successful!</div>
          )}
        </form>
      </main>
    </main>
  );
}
